import { apiFetch } from "@/client/lib/api";

/**
 * Typed client for the customer SSH-key self-service endpoints. All requests are
 * scoped server-side to the authenticated user (RLS + user_id filter), so the
 * client never passes a tenant or user id.
 */

export interface SshKey {
  id: string;
  label: string | null;
  keyType: string;
  /** Normalized `ssh-ed25519 <base64>` public key (comment stripped). */
  publicKey: string;
  fingerprint: string;
  comment: string | null;
  /** Owner's name - only populated in the staff "view as" tenant-wide listing. */
  ownerName: string | null;
  createdAt: string;
}

export interface CreateSshKeyInput {
  publicKey: string;
  label?: string;
}

export const sshKeysApi = {
  list: () => apiFetch<{ keys: SshKey[] }>("/ssh-keys"),
  create: (input: CreateSshKeyInput) =>
    apiFetch<SshKey>("/ssh-keys", { method: "POST", json: input }),
  remove: (id: string) => apiFetch<void>(`/ssh-keys/${id}`, { method: "DELETE" }),
};
